<template>
  <div>
    <h3 class="font-semibold text-gray-700 text-xl">Rides</h3>
    <div class="flex space-x-4">
      <div class="w-1/4">
        <label>
          <p>From</p>
          <v-date-picker :value="date.start"></v-date-picker>
        </label>
      </div>
      <div class="w-1/4">
        <label>
          <p>To</p>
          <v-date-picker :value="date.end"></v-date-picker>
        </label>
      </div>
    </div>
    <div
      class="mt-4 inline-block min-w-full shadow rounded-lg overflow-hidden box-border"
    >
      <table class="min-w-full leading-normal">
        <thead>
          <tr>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              Passenger Name
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              Driver Name
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              Pick / Drop Address
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              Date
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              Ride Fare
            </th>
          </tr>
        </thead>
        <tbody v-if="corporateTrips.length">
          <tr v-for="ride in corporateTrips" :key="ride._id">
            <!-- <tr v-for="ride in 10" :key="ride"> -->
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              {{ride.passenger.firstName + " " + ride.passenger.lastName}}
            </td>
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              {{ride.driver.firstName + " " + ride.driver.lastName}}
            </td>
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <div class="flex items-center space-x-2">
                <i class="material-icons text-green-600">location_on</i>
                <span>
                  {{ride.pickUpAddress.name}}
                </span>
              </div>
              <div class="flex items-center space-x-2">
                <i class="material-icons text-red-600">location_on</i>
                <span>
                  {{ride.dropOffAddress.name}}
                </span>
              </div>
            </td>
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <p class="text-gray-900 whitespace-no-wrap">
                {{formatDate(ride.pickupTimestamp)}}
              </p>
              <p class="mt-1 text-gray-900 whitespace-no-wrap">
                {{formatDate(ride.endTimestamp)}}
              </p>
            </td>
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <p class="text-gray-900 whitespace-no-wrap">
                {{ ride.fare }}
              </p>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <!-- <tbody> -->
          <tr>
            <td
              colspan="7"
              class="bg-white py-4 text-center text-gray-600 font-semibold"
            >
              <div v-if="loading" class="inline-block">
                <i class="material-icons text-6xl spin">sync</i>
                <span class="block invisible">Loading...</span>
              </div>
              <div v-else class="inline-block">
                <i class="material-icons text-6xl">warning</i>
                <span class="block">No latest rides!</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
    props: ['corporate'],
  data() {
    return {
      corporates: [],
      corporateTrips: [],
      date: {
        start: null,
        end: null,
      },
      loading: false,
    };
  },
  watch: {
    corporate() {
      this.getCorporateTrips();
    },
  },
  created() {
    this.getCorporateTrips();
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMM D, YYYY HH:mm");
    },
    getCorporateTrips() {
      console.log(this.corporate);
      this.$http
        .get(`/corporates/${this.corporate._id}/trips`)
        .then(response => (this.corporateTrips = response.data))
        .catch(err => console.log(err));
    },
  },
};
</script>
